export const procurementPtBr = {
  breadcrumbs: {
    ap: 'Contas a pagar',
    procurement: 'Compras',
    policies: 'Políticas',
    newRequest: 'Nova requisição',
  },
  list: {
    title: 'Compras',
    subtitle: 'Requisições de compra, aprovações e pedidos de compra',
    newRequest: 'Nova requisição',
    newOrder: 'Novo pedido de compra',
    searchPlaceholder: 'Buscar por número ou título',
    requestStatusFilter: 'Status da requisição',
    orderStatusFilter: 'Status do pedido',
    allRequestStatuses: 'Todos os status de requisição',
    allOrderStatuses: 'Todos os status de pedido',
    tabs: {
      requests: 'Requisições de compra',
      orders: 'Pedidos de compra',
    },
    pages: {
      requestsTitle: 'Requisições de compra',
      ordersTitle: 'Pedidos de compra',
    },
    countRequests_one: '{{count}} requisição',
    countRequests_other: '{{count}} requisições',
    countOrders_one: '{{count}} pedido',
    countOrders_other: '{{count}} pedidos',
    actions: {
      menuLabel: 'Ações de {{number}}',
      edit: 'Editar',
      submit: 'Enviar',
      cancelRequest: 'Cancelar requisição',
      cancelOrder: 'Cancelar pedido',
    },
    cancelDialog: {
      requestTitle: 'Cancelar requisição?',
      requestDescription: 'A requisição {{number}} será cancelada.',
      orderTitle: 'Cancelar pedido?',
      orderDescription: 'O pedido {{number}} será cancelado.',
    },
    columns: {
      number: 'Número',
      title: 'Título',
      status: 'Status',
      amount: 'Valor',
      total: 'Total',
      requester: 'Solicitante',
      created: 'Criado em',
      needBy: 'Necessário até',
      approved: 'Aprovado em',
      ready: 'Pronto em',
      expires: 'Expira em',
      owner: 'Responsável',
      createdBy: 'Criado por',
      originRequest: 'Requisição de origem',
      relatedOrders: 'Pedidos gerados',
      actions: 'Ações',
      customize: 'Colunas',
      customizeHint: 'Escolha as colunas exibidas na listagem.',
      reorderHint: 'Arraste pela alça para alterar a ordem das colunas na tabela.',
      resetOrder: 'Restaurar ordem padrão',
      dragHandleAria: 'Reordenar coluna',
      dataType: {
        date: 'Data',
        text: 'Texto',
        status: 'Status',
        currency: 'Valor',
        classification: 'Classificação',
        boolean: 'Sim/Não',
        actions: 'Ações',
      },
    },
    loading: 'Carregando...',
    loadingRequests: 'Carregando requisições de compra...',
    loadingOrders: 'Carregando pedidos de compra...',
    requestsLoadError: 'Não foi possível carregar as requisições de compra.',
    ordersLoadError: 'Não foi possível carregar os pedidos de compra.',
    loadErrorDescription: 'Verifique sua conexão e tente novamente.',
    retry: 'Tentar novamente',
    backToList: 'Voltar para a lista',
    permissionDeniedTitle: 'Você não tem acesso a este registro.',
    permissionDeniedDescription:
      'Solicite a permissão necessária a um administrador ou volte para a lista.',
    emptyRequests: 'Nenhuma requisição de compra encontrada.',
    emptyOrders: 'Nenhum pedido de compra encontrado.',
    emptyFilteredDescription: 'Ajuste ou remova os filtros para ver outros resultados.',
    emptyState: {
      requestsTitle: 'Nenhuma requisição de compra ainda',
      requestsDescription:
        'Crie sua primeira requisição de compra para iniciar o fluxo de aprovação.',
      ordersTitle: 'Nenhum pedido de compra ainda',
      ordersDescriptionDirect: 'Crie seu primeiro pedido de compra para começar.',
      ordersDescriptionRequiresRequest:
        'Pedidos de compra precisam ser originados de uma requisição aprovada. Crie uma requisição para começar, ou ajuste as configurações para permitir pedidos diretos.',
      editSettings: 'Editar configurações',
    },
    activeFilters: {
      label: 'Filtros ativos',
      clearAll: 'Limpar todos',
      none: 'Nenhum',
      dateRange: '{{from}} – {{to}}',
      dateFrom: 'A partir de {{from}}',
      dateTo: 'Até {{to}}',
      amountValue: '{{operator}} {{value}}',
    },
    pagination: {
      page: 'Página',
      of: 'de',
      results: 'resultados',
      previous: 'Anterior',
      next: 'Próxima',
      perPage: '/ página',
      pageSize: 'Itens por página',
    },
    exploration: {
      density: {
        label: 'Densidade da tabela',
        decrease: 'Diminuir tamanho das linhas',
        increase: 'Aumentar tamanho das linhas',
        levels: {
          compact: 'Compacta',
          default: 'Padrão',
          comfortable: 'Confortável',
        },
      },
      grouping: {
        label: 'Agrupar por',
        expandAll: 'Expandir tudo',
        collapseAll: 'Minimizar tudo',
        emptyValue: 'Sem informação',
        itemCount_one: '{{count}} registro',
        itemCount_other: '{{count}} registros',
        options: {
          none: 'Sem agrupamento',
          requester: 'Criado por',
          status: 'Status',
          created: 'Criado em',
          approved: 'Aprovado em',
          originRequest: 'Requisição de origem',
        },
      },
    },
    table: {
      filterColumnTooltip: 'Clique para filtrar por essa coluna',
      sortBy: 'Ordenar por {{column}}',
    },
    filters: {
      numberPlaceholder: 'Filtrar por número',
      titlePlaceholder: 'Filtrar por título',
      requesterPlaceholder: 'Filtrar por solicitante',
      relatedOrdersPlaceholder: 'Filtrar por pedido gerado',
      originRequestPlaceholder: 'Filtrar por requisição de origem',
      noRequesterOptions: 'Nenhum usuário encontrado.',
      amountPlaceholder: 'Valor',
      createdDatePlaceholder: 'Filtrar por data de criação',
      needByDatePlaceholder: 'Filtrar por necessário até',
      approvedDatePlaceholder: 'Filtrar por data de aprovação',
      readyDatePlaceholder: 'Filtrar por data de pronto',
      expiresDatePlaceholder: 'Filtrar por data de expiração',
    },
    amountOperators: {
      eqSymbol: '=',
      gteSymbol: '≥',
      lteSymbol: '≤',
    },
  },
  requestStatus: {
    OPEN: 'Aberto',
    PENDING_APPROVAL: 'Aguardando aprovação',
    APPROVED: 'Aprovado',
    CONVERTED: 'Convertido',
    REJECTED: 'Rejeitado',
    CANCELLED: 'Cancelado',
  },
  purchaseType: {
    ONE_TIME: 'Avulsa',
    RECURRING: 'Recorrente',
    BLANKET: 'Contrato guarda-chuva',
  },
  approvalStepStatus: {
    PENDING: 'Pendente',
    IN_PROGRESS: 'Em andamento',
    APPROVED: 'Aprovado',
    REJECTED: 'Rejeitado',
    SKIPPED: 'Ignorado',
    ESCALATED: 'Escalado',
  },
  orderStatus: {
    OPEN: 'Aberto',
    READY: 'Pronto',
    PARTIALLY_RECEIVED: 'Parcialmente recebido',
    RECEIVED: 'Recebido',
    FULFILLED: 'Atendido',
    SETTLED: 'Liquidado',
    COMPLETED: 'Concluído',
    CANCELLED: 'Cancelado',
  },
  orderForm: {
    title: 'Novo pedido de compra',
    subtitle: 'Crie um pedido diretamente, sem requisição prévia.',
    disabledByPolicy:
      'Pedidos sem requisição estão desabilitados nas configurações de compras do tenant.',
    createSuccess: 'Pedido de compra criado',
    createError: 'Não foi possível criar o pedido de compra',
  },
  form: {
    title: 'Nova requisição de compra',
    subtitle: 'Crie uma requisição que será encaminhada para aprovação de compras.',
    requestDetails: 'Detalhes da requisição',
    lineItems: 'Itens',
    attachments: 'Anexos',
    attachmentsDescription: 'Especificações, contratos, aprovações ou outros documentos de apoio.',
    summary: 'Resumo',
    estimatedAmount: 'Estimativa dos itens',
    budgetRequestedAmount: 'Orçamento solicitado',
    expectedAmount: 'Valor esperado',
    finalAmount: 'Valor final negociado',
    paymentTerms: 'Condições de pagamento',
    paymentTermsPlaceholder: 'Ex.: 30 dias, 50% na entrega e 50% em 30 dias',
    responsibleUser: 'Responsável pela verificação',
    entity: 'Entidade',
    vendor: 'Fornecedor',
    vendors: 'Fornecedores',
    department: 'Departamento',
    number: 'Número',
    numberAutoGenerated: 'Atribuído automaticamente ao salvar',
    costCenter: 'Centro de custo',
    managerialAccount: 'Conta gerencial',
    glAccount: 'Conta contábil',
    glAccountStale: 'Desatualizada',
    glAccountStaleHint:
      'A classificação pertence a uma versão anterior do plano de contas ou não tem versão registrada. Reclassifique para o plano aplicável.',
    glAccountRemap: 'Reclassificar conta',
    glAccountRemapDialogTitle: 'Reclassificar conta contábil',
    glAccountRemapDialogDescription:
      'Selecione a conta equivalente para o cabeçalho e para cada linha já classificada. A alteração só será concluída quando todas estiverem na mesma versão do plano de contas.',
    glAccountRemapDialogDescriptionLinesOnly:
      'Revise as contas das linhas já classificadas. A alteração só será concluída quando todas estiverem na mesma versão do plano de contas.',
    glAccountRemapDialogDescriptionLine:
      'Selecione a conta equivalente no plano de contas vigente da entidade para a linha {{lineNumber}} ({{description}}). Apenas a conta contábil desta linha é alterada.',
    glAccountRemapCurrent: 'Conta atual',
    glAccountRemapNew: 'Nova conta',
    glAccountRemapSelectionsRequired: 'Selecione a nova conta para: {{pending}}.',
    glAccountRemapSelectionPending:
      'Selecione outra conta equivalente nesta versão do plano de contas.',
    glAccountRemapPendingHeader: 'cabeçalho do pedido',
    glAccountRemapPendingLine: 'linha {{lineNumber}} ({{description}})',
    glAccountRemapLinesTitle: 'Contas das linhas classificadas',
    glAccountRemapLinesDescription:
      'Linhas válidas mantêm a conta atual. Selecione outra conta somente para as linhas pendentes.',
    glAccountRemapConfirm: 'Reclassificar',
    glAccountRemapSuccess: 'Todas as contas classificadas do pedido foram reclassificadas.',
    glAccountRemapBillSuccess:
      'O pedido foi reclassificado na versão do plano de contas da fatura.',
    glAccountRemapLineSuccess: 'A conta contábil da linha foi reclassificada.',
    glAccountRemapPartial:
      'A reclassificação ficou incompleta. Ainda falta: {{pending}}. Selecione outra conta equivalente nessa versão e confirme novamente.',
    glAccountRemapError: 'Não foi possível reclassificar a conta contábil.',
    glAccountRemapNoTargetsTitle: 'Nenhuma classificação para reclassificar',
    glAccountRemapNoTargets:
      'Este pedido não possui conta contábil no cabeçalho nem linhas classificadas. Nenhuma alteração foi realizada.',
    glAccountRemapBlockedTitle: 'Este pedido não pode ser reclassificado',
    glAccountRemapBlockedStatus:
      'O pedido está com status “{{status}}”, que não permite alterar a classificação contábil.',
    glAccountRemapBlockedPermission:
      'Você não tem permissão para alterar a classificação contábil deste pedido.',
    glAccountRemapAccountingDate: 'Data de referência (opcional)',
    glAccountRemapAccountingDateHint:
      'Deixe em branco para reclassificar no plano de contas vigente. Informe uma data para resolver o plano em vigor naquela data, caso a classificação precise refletir uma versão anterior após mais de um corte de plano de contas.',
    glAccountRemapAccountingDateBillHint:
      'Esta data vem da competência ou emissão da fatura bloqueada e mantém todas as seleções no plano de contas resolvido para ela.',
    glAccountRemapBillContext:
      'Remapeamento solicitado pela fatura {{billNumber}}, com data contábil {{accountingDate}}. Abrir fatura.',
    glAccountRemapBill: 'vinculada',
    glAccountRemapHistoricalTitle: 'Classificação na versão da fatura',
    glAccountRemapHistoricalNote:
      'Este pedido está classificado na versão do plano de contas da fatura {{billNumber}}, referente a {{accountingDate}}.',
    glAccountRemapOpenBill: 'Abrir fatura {{billNumber}}',
    lineGlAccountRemediationTitle: 'Linhas com conta contábil desatualizada',
    lineGlAccountRemediationDescription:
      'Estas linhas estão em uma versão anterior ou sem versão registrada. Reclassifique cada uma para o plano aplicável.',
    classification: 'Classificação',
    customSegments: 'Campos customizados',
    customSegmentsHint: 'Segmentos usados no matching de orçamento desta requisição.',
    titleField: 'Título',
    needByDate: 'Data necessária',
    needByDateHint: 'Quando os bens ou serviços precisam estar disponíveis',
    firstPaymentDate: 'Data primeiro pagamento',
    purchaseType: 'Tipo de compra',
    recurringSchedule: 'Programação recorrente',
    recurrenceFrequency: 'Frequência',
    perOccurrenceAmount: 'Valor por ocorrência',
    recurringSince: 'Início da recorrência',
    recurringUntil: 'Fim da recorrência',
    recurrenceFrequencyOptions: {
      WEEKLY: 'Semanal',
      MONTHLY: 'Mensal',
      BIMONTHLY: 'Bimestral',
      QUARTERLY: 'Trimestral',
      SEMESTERLY: 'Semestral',
      YEARLY: 'Anual',
    },
    tooltips: {
      purchaseType:
        'Avulsa: compra única (equipamento, projeto pontual). Recorrente: pagamentos repetidos (aluguel, assinatura, contrato).',
      purchaseTypeAria: 'Ajuda sobre tipo de compra',
      needByDate: 'Quando os bens ou serviços precisam estar disponíveis ou entregues.',
      firstPaymentDate: 'Data em que o primeiro pagamento desta compra recorrente deve ocorrer.',
      recurrenceFrequency: 'Com que frequência o pagamento se repete (mensal, trimestral, etc.).',
      recurrenceFrequencyAria: 'Ajuda sobre frequência da recorrência',
      perOccurrenceAmount:
        'Valor de cada parcela ou fatura recorrente. Usado para gerar o template de conta recorrente e os compromissos mensais.',
      perOccurrenceAmountAria: 'Ajuda sobre valor por ocorrência',
      recurringSince:
        'Data da primeira ocorrência prevista. Define quando os compromissos recorrentes começam.',
      recurringSinceAria: 'Ajuda sobre início da recorrência',
      recurringUntil:
        'Opcional. Data da última ocorrência prevista. Deixe vazio para contratos sem data final.',
      recurringUntilAria: 'Ajuda sobre fim da recorrência',
      budgetRequestedAmount:
        'Valor total a reservar no orçamento para aprovação. Pode ser maior que o valor estimado dos itens se você já conhece o teto do contrato.',
      budgetRequestedAmountAria: 'Ajuda sobre orçamento solicitado',
      responsibleUser:
        'Pessoa que valida cotações e confirma condições com o fornecedor antes do pedido ficar pronto para faturamento.',
      responsibleUserAria: 'Ajuda sobre responsável pela verificação',
      paymentTerms:
        'Prazos, parcelas ou condições negociadas (ex.: 30 dias, 50% na entrega e 50% em 30 dias).',
      paymentTermsAria: 'Ajuda sobre condições de pagamento',
      vendors:
        'Fornecedores candidatos. Opcional na requisição — pode ser definido ao marcar o pedido como pronto.',
      vendorsAria: 'Ajuda sobre fornecedores',
      estimatedAmount:
        'Soma dos itens da requisição. Usado como referência; o orçamento usa o valor em Orçamento solicitado.',
      estimatedAmountAria: 'Ajuda sobre valor estimado',
    },
    description: 'Descrição',
    selectEntity: 'Selecione a entidade',
    selectEntityFirst: 'Selecione uma entidade primeiro.',
    select: 'Selecione',
    optionalVendor: 'Fornecedor opcional',
    optionalDepartment: 'Departamento opcional',
    optionalCostCenter: 'Centro de custo opcional',
    titlePlaceholder: 'O que está sendo solicitado?',
    datePlaceholder: 'dd/mm/aaaa',
    currencyPlaceholder: '0,00',
    descriptionPlaceholder: 'Contexto para os aprovadores',
    addLine: 'Adicionar item',
    removeLine: 'Remover item',
    lineDescription: 'Descrição',
    quantity: 'Qtd.',
    unitPrice: 'Preço unitário',
    amount: 'Total',
    lineSubtotal: 'Subtotal do item',
    cancel: 'Cancelar',
    createRequest: 'Criar requisição',
    editTitle: 'Editar requisição de compra',
    editBreadcrumb: 'Editar requisição',
    saveChanges: 'Salvar alterações',
    loadingRequest: 'Carregando requisição de compra...',
    notEditable: 'Somente requisições abertas podem ser editadas.',
    updateSuccess: 'Requisição de compra atualizada.',
    updateError: 'Não foi possível atualizar a requisição de compra.',
    requiredFieldsError: 'Preencha os campos obrigatórios.',
    fieldErrors: {
      vendorsRequired: 'Selecione pelo menos um fornecedor.',
      entityRequired: 'Selecione a entidade.',
      titleRequired: 'Informe o título.',
      needByDateRequired: 'Informe uma data válida no formato dd/mm/aaaa.',
      budgetRequestedRequired: 'Informe o orçamento solicitado.',
      positiveTotalRequired: 'Informe pelo menos um item com valor positivo.',
      recurrenceFrequencyRequired: 'Selecione a frequência.',
      recurringSinceRequired: 'Informe o início da recorrência.',
      perOccurrenceAmountRequired: 'Informe o valor por ocorrência.',
      recurringUntilInvalid: 'Informe uma data final válida no formato dd/mm/aaaa.',
      recurringUntilBeforeStart: 'A data final deve ser posterior ou igual à data de início.',
    },
    createSuccess: 'Requisição de compra criada.',
    createError: 'Não foi possível criar a requisição de compra.',
    recurringScheduleValidationError:
      'Informe frequência, início da recorrência e valor por ocorrência. Se informar fim, ele deve ser posterior ao início.',
    recurringClassificationMismatch:
      'Pedidos recorrentes exigem que todos os itens usem a mesma classificação do cabeçalho.',
    loadErrorTitle: 'Não foi possível carregar o formulário.',
    loadErrorDescription: 'Verifique sua conexão e tente novamente.',
    retry: 'Tentar novamente',
    unsavedChanges: {
      title: 'Descartar alterações?',
      description: 'As alterações ainda não foram salvas e serão perdidas se você sair.',
      proceed: 'Sair sem salvar',
      stay: 'Continuar editando',
    },
    uploadPartial: 'Requisição criada, mas alguns anexos não foram enviados.',
    upload: {
      dropTitle: 'Arraste arquivos ou clique para selecionar',
      dropHint: 'PDF, imagens ou planilhas — até {{max}} arquivos',
      dropActive: 'Solte os arquivos aqui',
      selectFiles: 'Selecionar arquivos',
      filesSelected: '{{count}} arquivo(s) selecionado(s)',
    },
  },
  requestDetail: {
    subtitle: 'Requisição de compra {{number}}',
    tabs: {
      items: 'Itens',
      approval: 'Aprovação',
      details: 'Detalhes',
    },
    summary: {
      requester: 'Solicitante',
      entity: 'Entidade',
      vendor: 'Fornecedor',
      created: 'Criado em',
      needByDate: 'Data necessária',
      purchaseType: 'Tipo de compra',
      description: 'Descrição',
      department: 'Departamento',
      costCenter: 'Centro de custo',
      managerialAccount: 'Conta gerencial',
      glAccount: 'Conta contábil',
      customSegments: 'Campos customizados',
      number: 'Número',
      notSet: '—',
    },
    lineItems: 'Itens',
    vendorQuotes: {
      title: 'Cotação de fornecedores',
      helper:
        'Registre as propostas recebidas nesta requisição e compare os fornecedores antes de escolher a vencedora.',
      vendor: 'Fornecedor',
      amount: 'Valor cotado',
      amountRequired: 'Informe o valor cotado.',
      validUntil: 'Validade',
      validUntilInvalid: 'Informe uma data de validade válida no formato dd/mm/aaaa.',
      note: 'Observações',
      attachments: 'Anexos',
      selected: 'Vencedora',
      editQuote: 'Editar',
      completeQuote: 'Completar cotação',
      selectWinner: 'Selecionar vencedora',
      requirementProgress:
        '{{registered}} de {{minimum}} cotações registradas. Faltam {{missing}} para converter em pedido.',
      requirementNeedsMoreVendors:
        '{{registered}} de {{minimum}} cotações registradas. Todos os fornecedores vinculados já têm cotação — adicione mais {{missing}} fornecedor(es) para atingir o mínimo e converter em pedido.',
      requirementReady:
        '{{minimum}} cotações registradas. Você já pode comparar as propostas e escolher uma vencedora.',
      recordQuote: 'Registrar cotação',
      uploadAttachment: 'Anexar cotação',
      openingAttachment: 'Abrindo anexo...',
      openAttachmentError: 'Não foi possível abrir o anexo.',
      showAllQuotes: 'Ver outras cotações ({{count}})',
      showFewerQuotes: 'Ocultar outras cotações',
      empty: 'Nenhuma cotação registrada.',
      emptyHint: 'Adicione a primeira proposta para iniciar a comparação de fornecedores.',
      emptyReadOnlyHint: 'As cotações serão exibidas aqui quando forem registradas.',
      addQuote: 'Adicionar cotação',
      allVendorsQuoted: 'Todos os fornecedores vinculados já têm uma cotação registrada.',
      noLinkedVendors: 'Adicione fornecedores ao pedido antes de registrar cotações.',
      formTitle: 'Nova cotação',
      editQuoteTitle: 'Editar cotação',
      completeQuoteTitle: 'Completar cotação',
      formHint: 'Selecione o fornecedor e registre os dados da proposta recebida.',
      closeForm: 'Fechar',
      cancel: 'Cancelar',
      notInformed: 'Não informado',
      amountRequiredForWinner: 'Sem valor cotado. Edite para informar o valor.',
      vendorRequired: 'Selecione um fornecedor.',
      recordQuoteSuccess: 'Cotação registrada.',
      recordQuoteError: 'Não foi possível registrar a cotação.',
      selectedQuoteChangeRequiresAmendment:
        'Alterações na cotação vencedora exigem um aditivo do pedido de compra após ele estar pronto.',
      selectWinnerSuccess: 'Fornecedor vencedor selecionado.',
      selectWinnerError: 'Não foi possível selecionar o fornecedor vencedor.',
      uploadAttachmentSuccess: 'Cotação anexada.',
      uploadAttachmentError: 'Não foi possível anexar a cotação.',
    },
    approvalChain: 'Cadeia de aprovação',
    status: 'Status',
    estimatedAmount: 'Estimativa dos itens',
    vendorId: 'ID do fornecedor',
    convertedMessage: 'Esta requisição foi convertida em pedido de compra.',
    convertedOrderMessage: 'Esta requisição foi convertida para o pedido de compra',
    needByDateOverdue: 'A data necessária já passou. A requisição pode não ser atendida a tempo.',
    viewOrders: 'Ver pedidos',
    noApprovalChain: 'Nenhuma cadeia de aprovação ainda.',
    noAssignee: 'Sem responsável',
    loading: 'Carregando requisição de compra...',
    notFound: 'Requisição de compra não encontrada.',
    loadErrorTitle: 'Não foi possível carregar a requisição de compra.',
    loadErrorDescription: 'Verifique sua conexão e tente novamente.',
    back: 'Voltar',
    edit: 'Editar',
    cancelRequest: 'Cancelar requisição',
    submit: 'Enviar',
    retrySubmit: 'Reenviar',
    reject: 'Rejeitar',
    approve: 'Aprovar',
    submitSuccess: 'Requisição enviada para aprovação.',
    submitError: 'Não foi possível enviar a requisição de compra.',
    noApproversConfigured:
      'Não há aprovadores configurados para esta etapa. Configure os aprovadores antes de enviar.',
    approveSuccess: 'Requisição de compra aprovada.',
    approveError: 'Não foi possível aprovar a requisição de compra.',
    budgetConfirmation: {
      title: 'Nenhuma linha orçamentária correspondente',
      description:
        'Não há linha orçamentária ativa que corresponda a um ou mais itens desta requisição. O pedido de compra será criado sem reserva orçamentária.',
      linesLabel: 'Itens sem correspondência: {{lines}}',
      confirm: 'Aprovar sem reserva orçamentária',
      cancel: 'Voltar para editar',
    },
    budgetBlock: {
      hardTitle: 'Aprovação bloqueada — orçamento excedido',
      hardDescription:
        'A aprovação final criaria um compromisso acima do limite da linha orçamentária abaixo. Reduza o valor, ajuste as dimensões ou edite o orçamento antes de aprovar.',
      softTitle: 'Exceção orçamentária necessária',
      softDescription:
        'A aprovação final excederia uma linha com bloqueio flexível. Solicite e obtenha aprovação de uma exceção antes de concluir a aprovação.',
      blockingLine: 'Linha bloqueadora',
      assessedPeriod: 'Período avaliado',
      lineLimitSuffix: 'limite da linha',
      excessAmount: 'Excedente: {{amount}}',
      hardActions:
        'Edite a requisição para reduzir o valor, altere centro de custo/conta gerencial ou aumente o limite da linha no orçamento.',
      softActions:
        'Solicite uma exceção orçamentária para esta requisição ou reduza o valor antes de aprovar.',
      requestException: 'Solicitar exceção',
      exceptionPending: 'Exceção orçamentária pendente de aprovação financeira.',
      exceptionApproved: 'Exceção aprovada — você pode concluir a aprovação.',
      requestExceptionDialogTitle: 'Solicitar exceção orçamentária',
      requestExceptionDialogDescription:
        'Descreva por que esta requisição deve ser aprovada acima do limite da linha {{lineName}}.',
      requestExceptionJustificationPlaceholder: 'Justificativa da exceção',
      requestExceptionSubmit: 'Enviar solicitação',
      requestExceptionSuccess: 'Exceção orçamentária solicitada.',
      requestExceptionError: 'Não foi possível solicitar a exceção orçamentária.',
      dimensionFallback: {
        COST_CENTER: 'Centro de custo',
        DEPARTMENT: 'Departamento',
        COMPANY: 'Empresa',
      },
    },
    rejectSuccess: 'Requisição de compra rejeitada.',
    rejectError: 'Não foi possível rejeitar a requisição de compra.',
    cancelSuccess: 'Requisição de compra cancelada.',
    cancelError: 'Não foi possível cancelar a requisição de compra.',
    columns: {
      lineNumber: '#',
      description: 'Descrição',
      quantity: 'Qtd.',
      unitPrice: 'Valor unit.',
      total: 'Total',
    },
    sections: {
      requestDetails: 'Detalhes da solicitação',
      requestedItems: 'Itens solicitados',
      attachments: 'Anexos',
      approvalFlow: 'Fluxo de aprovação',
      generatedOrders: 'Pedidos de compra gerados',
    },
    summaryCard: {
      items: 'Itens',
      attachments: 'Anexos',
      generatedOrders: 'Pedidos gerados',
      budgetStatus: 'Status orçamentário',
      budgetWithinLimit: 'Dentro do limite',
      itemUnits: '{{count}} item · {{units}} unidades',
      itemUnits_other: '{{count}} itens · {{units}} unidades',
    },
    vendorPendingConversion: 'A definir na conversão',
    noDescription: 'Sem descrição',
    estimatedTotal: 'Total estimado dos itens',
    attachmentsEmpty: 'Nenhum anexo ainda.',
    addAttachment: 'Adicionar anexo',
    uploadSuccess: 'Anexo enviado com sucesso.',
    uploadError: 'Falha ao enviar anexo.',
    attachmentsLoading: 'Carregando anexos...',
    openingAttachment: 'Abrindo anexo...',
    openAttachmentError: 'Não foi possível abrir o anexo.',
    showAllAttachments: 'Ver outros anexos ({{count}})',
    showFewerAttachments: 'Ocultar outros anexos',
    closeAttachmentUpload: 'Fechar',
    deleteAttachment: 'Remover anexo',
    deleteAttachmentConfirmTitle: 'Remover anexo?',
    deleteAttachmentConfirmDescription:
      'O anexo "{{name}}" será removido definitivamente. Essa ação não pode ser desfeita.',
    deleteAttachmentSuccess: 'Anexo removido.',
    deleteAttachmentError: 'Não foi possível remover o anexo.',
    generatedOrdersEmpty:
      'Nenhum pedido gerado ainda. Após a aprovação final, o pedido será criado automaticamente.',
    generatedOrdersRestricted:
      'Há pedidos relacionados, mas você não tem permissão para visualizá-los.',
  },
  orderDetail: {
    subtitle: 'Pedido de compra {{number}}',
    edit: 'Editar',
    editTitle: 'Editar pedido de compra',
    editBreadcrumb: 'Editar pedido',
    tabs: {
      items: 'Itens',
      details: 'Detalhes',
    },
    summary: {
      entity: 'Entidade',
      vendor: 'Fornecedor',
      approved: 'Aprovado em',
      created: 'Criado em',
      billed: 'Faturado',
      sourceRequest: 'Requisição de origem',
      number: 'Número',
      notSet: '—',
    },
    lineItems: 'Itens',
    vendorQuotes: {
      title: 'Cotação de fornecedores',
      helper:
        'Consulte as propostas deste pedido. Em pedidos abertos, ao selecionar a vencedora, o valor final negociado é atualizado.',
      vendor: 'Fornecedor',
      amount: 'Valor cotado',
      amountRequired: 'Informe o valor cotado.',
      validUntil: 'Validade',
      validUntilInvalid: 'Informe uma data de validade válida no formato dd/mm/aaaa.',
      note: 'Observações',
      attachments: 'Anexos',
      selected: 'Vencedora',
      editQuote: 'Editar',
      completeQuote: 'Completar cotação',
      selectWinner: 'Selecionar vencedora',
      requirementProgress:
        '{{registered}} de {{minimum}} cotações registradas. Faltam {{missing}} para marcar o pedido como pronto.',
      requirementNeedsMoreVendors:
        '{{registered}} de {{minimum}} cotações registradas. Todos os fornecedores vinculados já têm cotação — adicione mais {{missing}} fornecedor(es) para atingir o mínimo e marcar o pedido como pronto.',
      requirementReady:
        '{{minimum}} cotações registradas. Você já pode marcar o pedido como pronto.',
      recordQuote: 'Registrar cotação',
      uploadAttachment: 'Anexar cotação',
      openingAttachment: 'Abrindo anexo...',
      openAttachmentError: 'Não foi possível abrir o anexo.',
      showAllQuotes: 'Ver outras cotações ({{count}})',
      showFewerQuotes: 'Ocultar outras cotações',
      empty: 'Nenhuma cotação registrada.',
      emptyHint: 'Adicione uma proposta para iniciar a comparação de fornecedores.',
      emptyReadOnlyHint: 'As cotações serão exibidas aqui quando forem registradas.',
      addQuote: 'Adicionar cotação',
      allVendorsQuoted: 'Todos os fornecedores vinculados já têm uma cotação registrada.',
      noLinkedVendors: 'Adicione fornecedores ao pedido antes de registrar cotações.',
      formTitle: 'Nova cotação',
      editQuoteTitle: 'Editar cotação',
      completeQuoteTitle: 'Completar cotação',
      formHint: 'Selecione o fornecedor e registre os dados da proposta.',
      closeForm: 'Fechar',
      cancel: 'Cancelar',
      notInformed: 'Não informado',
      amountRequiredForWinner: 'Sem valor cotado. Edite para informar o valor.',
      vendorRequired: 'Selecione um fornecedor.',
      recordQuoteSuccess: 'Cotação registrada.',
      recordQuoteError: 'Não foi possível registrar a cotação.',
      selectedQuoteChangeRequiresAmendment:
        'Alterações na cotação vencedora exigem um aditivo do pedido de compra após ele estar pronto.',
      selectWinnerSuccess: 'Fornecedor vencedor selecionado.',
      selectWinnerError: 'Não foi possível selecionar o fornecedor vencedor.',
      uploadAttachmentSuccess: 'Cotação anexada.',
      uploadAttachmentError: 'Não foi possível anexar a cotação.',
    },
    status: 'Status',
    totalAmount: 'Valor total',
    approved: 'Aprovado',
    billed: 'Faturado',
    sourceRequest: 'Requisição de origem',
    loading: 'Carregando pedido de compra...',
    notFound: 'Pedido de compra não encontrado.',
    back: 'Voltar',
    cancelOrder: 'Cancelar pedido',
    markReady: 'Marcar como pronto',
    markFulfilled: 'Marcar como atendido',
    readySuccess: 'Pedido marcado como pronto.',
    readyError: 'Não foi possível marcar o pedido como pronto.',
    fulfillSuccess: 'Pedido marcado como atendido.',
    fulfillError: 'Não foi possível marcar o pedido como atendido.',
    recordReceipt: 'Registrar recebimento',
    linkedReceipt: {
      title: 'Recebimento do pedido',
      loading: 'Carregando recebimento',
      errorTitle: 'Não foi possível abrir o recebimento',
      errorDescription: 'Atualize os dados ou tente novamente.',
      receiptId: 'Identificador do recebimento',
      note: 'Observação',
      lines: 'Itens recebidos',
      quantity: 'Quantidade: {{quantity}}',
    },
    receiveDialogTitle: 'Registrar recebimento de mercadorias/serviços',
    receiveDialogDescription:
      'Informe quem recebeu e as quantidades recebidas por linha (correspondência três vias).',
    receiveSuccess: 'Recebimento registrado.',
    receiveError: 'Não foi possível registrar o recebimento.',
    receiveErrorDetails: {
      lineRepeated:
        'O mesmo item foi informado mais de uma vez no recebimento. Revise as linhas e tente novamente.',
      lineNotFound:
        'Um dos itens informados não pertence mais a este pedido. Atualize a página e tente novamente.',
      quantityExceedsPending:
        'A quantidade disponível foi alterada ou já foi recebida. Atualize o pedido e tente novamente.',
    },
    receivedAt: 'Recebido em',
    readyDialogTitle: 'Marcar pedido como pronto',
    readyDialogDescription:
      'Confirme fornecedor, condições de pagamento, valor final e responsável pela verificação.',
    readyValidation: {
      vendorsRequired: 'Selecione pelo menos um fornecedor.',
      paymentTermsRequired: 'Informe as condições de pagamento.',
      finalAmountRequired: 'Informe o valor final.',
      responsibleUserRequired: 'Selecione o responsável pela verificação.',
      draftBillVendorRequired: 'Selecione o fornecedor da fatura rascunho.',
      recurringScheduleRequired:
        'Complete a programação recorrente no pedido antes de marcar como pronto.',
      buyerVerificationConflict:
        'O responsável pela verificação deve ser diferente do comprador que está marcando o pedido como pronto.',
    },
    receiveValidation: {
      responsibleUserRequired: 'Selecione quem recebeu os itens.',
      receiverBuyerConflict:
        'O recebedor deve ser diferente do comprador que marcou o pedido como pronto.',
      quantityPositive: 'Informe uma quantidade maior que zero.',
      quantityExceedsPending: 'Informe no máximo {{pending}} item(ns), que é o saldo pendente.',
      atLeastOneQuantity: 'Informe ao menos uma quantidade recebida maior que zero.',
    },
    receiptRequiredBeforeClose:
      'Registre o recebimento dos itens antes de marcar o pedido como atendido.',
    threeWayReceiptGate: 'Método de recebimento',
    threeWayReceiptGateHint: {
      BEFORE_BILL: 'O recebimento deve ser registrado antes de vincular ou enviar a fatura.',
      BEFORE_PO_CLOSE:
        'A fatura pode ser vinculada antes do recebimento; o recebimento é exigido para encerrar o pedido.',
    },
    draftBillVendor: 'Fornecedor da fatura (rascunho)',
    draftBillVendorHint:
      'Selecione qual fornecedor será usado na conta em rascunho gerada automaticamente.',
    cancelSuccess: 'Pedido de compra cancelado.',
    cancelError: 'Não foi possível cancelar o pedido de compra.',
    saveChanges: 'Salvar alterações',
    updateSuccess: 'Pedido de compra atualizado.',
    updateError: 'Não foi possível atualizar o pedido de compra.',
    uploadPartial: 'Pedido atualizado, mas alguns anexos não foram enviados.',
    uploadPartialDuplicateNames:
      'Arquivos com o mesmo nome falharam. Mantivemos todos selecionados; remova os que não quiser reenviar.',
    notEditable: 'Somente pedidos abertos podem ser editados.',
    loadErrorTitle: 'Não foi possível carregar o pedido de compra.',
    loadErrorDescription: 'Verifique sua conexão e tente novamente.',
    sections: {
      attachments: 'Anexos',
      linkedBills: 'Contas vinculadas',
      budgetCommitment: 'Linha de orçamento comprometida',
      sourceRequest: 'Requisição de origem',
    },
    sourceRequestEmpty: 'Este pedido não tem uma requisição de origem vinculada.',
    sourceRequestRestricted:
      'Há uma requisição de origem vinculada, mas você não tem permissão para visualizá-la.',
    relatedRequestLoading: 'Carregando requisição...',
    sourceRequestUnavailable: 'Não foi possível carregar a requisição de origem.',
    attachmentsEmpty: 'Nenhum anexo ainda.',
    addAttachment: 'Adicionar anexo',
    uploadSuccess: 'Anexo enviado com sucesso.',
    uploadError: 'Falha ao enviar anexo.',
    attachmentsLoading: 'Carregando anexos...',
    openingAttachment: 'Abrindo anexo...',
    openAttachmentError: 'Não foi possível abrir o anexo.',
    showAllAttachments: 'Ver outros anexos ({{count}})',
    showFewerAttachments: 'Ocultar outros anexos',
    closeAttachmentUpload: 'Fechar',
    deleteAttachment: 'Remover anexo',
    deleteAttachmentConfirmTitle: 'Remover anexo?',
    deleteAttachmentConfirmDescription:
      'O anexo "{{name}}" será removido definitivamente. Essa ação não pode ser desfeita.',
    deleteAttachmentSuccess: 'Anexo removido.',
    deleteAttachmentError: 'Não foi possível remover o anexo.',
    linkedBillsEmpty: 'Nenhuma conta vinculada a este pedido.',
    expiresAt: 'Validade do pedido',
    readyAt: 'Marcado como pronto',
    fulfilledAt: 'Atendido em',
    utilized: 'Utilizado',
    available: 'Disponível',
    utilization: 'Utilização',
    columns: {
      lineNumber: '#',
      description: 'Descrição',
      quantity: 'Qtd.',
      unitPrice: 'Valor unit.',
      total: 'Total',
    },
  },
  policies: {
    title: 'Políticas de compras',
    subtitle: 'Configure qual fluxo aprova cada requisição de compra',
    refresh: 'Atualizar',
    newPolicy: 'Nova política',
    searchPlaceholder: 'Buscar por nome ou descrição',
    showingActive: 'Exibindo ativas',
    showingAll: 'Exibindo todas',
    count: '{{count}} políticas',
    empty: 'Nenhuma política de compras encontrada.',
    noDescription: 'Sem descrição',
    noWorkflow: 'Sem fluxo',
    active: 'Ativa',
    inactive: 'Inativa',
    columns: {
      name: 'Nome',
      workflow: 'Fluxo',
      status: 'Status',
      priority: 'Prioridade',
      specificity: 'Especificidade',
    },
  },
  policyForm: {
    newTitle: 'Nova política de compras',
    editTitle: 'Política de compras',
    subtitle: 'Controle qual fluxo trata as aprovações de requisições de compra',
    back: 'Voltar',
    delete: 'Excluir',
    save: 'Salvar',
    deleteConfirm: 'Excluir esta política de compras?',
    createSuccess: 'Política criada.',
    updateSuccess: 'Política atualizada.',
    deleteSuccess: 'Política excluída.',
    saveError: 'Não foi possível salvar a política.',
    deleteError: 'Não foi possível excluir a política.',
    basics: 'Informações básicas',
    conditions: 'Condições do fluxo',
    summary: 'Resumo',
    name: 'Nome',
    description: 'Descrição',
    entity: 'Entidade',
    workflow: 'Fluxo',
    selectWorkflow: 'Selecione um fluxo',
    noWorkflow: 'Sem fluxo',
    status: 'Status',
    selectStatus: 'Selecione o status',
    priority: 'Prioridade',
    evaluationMode: 'Modo de avaliação',
    deterministic: 'Determinístico',
    ai: 'IA',
    vendor: 'Fornecedor',
    vendors: 'Fornecedores permitidos',
    requireVendorForApproval: 'Exigir fornecedor para aprovar requisições',
    department: 'Departamento',
    managerialAccount: 'Conta gerencial',
    glAccountId: 'ID da conta contábil',
    glAccountPlaceholder: 'ID manual opcional',
    autoApproveUpTo: 'Autoaprovar até',
    minAmount: 'Valor mínimo',
    maxAmount: 'Valor máximo',
    selectEntityFirst: 'Selecione uma entidade primeiro.',
    policyId: 'ID da política',
    specificity: 'Especificidade',
    created: 'Criado em',
    updated: 'Atualizado em',
  },
  labels: {
    loading: 'Carregando...',
  },
  filters: {
    all: 'Todos',
  },
  purchaseOrder: {
    selector: {
      label: 'Pedido de compra',
      placeholder: 'Selecione um pedido de compra',
      searchPlaceholder: 'Buscar por número ou título...',
      empty: 'Nenhum pedido de compra disponível.',
      notFound: 'Nenhum pedido de compra encontrado.',
      loading: 'Carregando pedidos de compra...',
      listHeading: 'Pedidos de compra',
      clearAria: 'Limpar seleção',
    },
    validation: {
      checking: 'Validando pedido de compra...',
      remapAction: 'Reclassificar pedido para esta fatura',
      remapDateRequired:
        'Preencha primeiro a data de competência ou de emissão da fatura para identificar o plano de contas correto.',
      EXPIRED: {
        title: 'Pedido expirado',
        description: 'O pedido de compra selecionado está expirado.',
      },
      FULFILLED: {
        title: 'Pedido totalmente faturado',
        description: 'O pedido de compra selecionado já foi totalmente faturado.',
      },
      NOT_READY: {
        title: 'Pedido não está pronto',
        description:
          'O pedido de compra precisa ser marcado como pronto antes de vincular a uma conta.',
      },
      AMOUNT_EXCEEDED: {
        title: 'Valor excede o pedido',
        description: 'O valor da conta excede o saldo disponível no pedido de compra.',
      },
      VENDOR_NOT_ALLOWED: {
        title: 'Fornecedor não permitido',
        description: 'O fornecedor da conta não está vinculado ao pedido de compra selecionado.',
      },
      GL_CLASSIFICATION_STALE: {
        title: 'Classificação desatualizada',
        description:
          'A conta contábil classificada neste pedido pertence a uma versão do plano de contas diferente da versão vigente para esta fatura. Reclassifique a conta antes de converter em fatura.',
      },
      GL_CLASSIFICATION_INCOMPLETE: {
        title: 'Classificação incompleta',
        description:
          'A conta contábil classificada neste pedido não tem versão do plano de contas registrada, então não pode ser validada contra a versão desta fatura. Reclassifique a conta antes de converter em fatura.',
      },
    },
  },
  globalSettings: {
    title: 'Configurações de compras',
    subtitle: 'Defina padrões globais para requisições e pedidos de compra',
    cardTitle: 'Padrões globais',
    loading: 'Carregando configurações...',
    allowPurchaseOrdersWithoutPurchaseRequest: 'Permitir pedidos sem requisição',
    allowPurchaseOrdersWithoutPurchaseRequestHint:
      'Quando ativo, compradores podem criar pedidos de compra diretamente, sem requisição prévia.',
    enforcePurchaseRequestSelfApprovalGuard: 'Impedir autoaprovação de requisições',
    enforcePurchaseRequestSelfApprovalGuardHint:
      'Quando ativo, o solicitante não pode aprovar a própria requisição de compra (segregação de funções).',
    requireVendor: 'Exigir fornecedor',
    requireVendorHint: 'Exige fornecedor vinculado antes de aprovar requisições de compra.',
    defaultPoExpirationDays: 'Validade padrão do pedido (dias)',
    defaultPoExpirationDaysHint: 'Deixe em branco para não aplicar validade padrão.',
    defaultAutoApproveUpTo: 'Autoaprovação padrão até',
    defaultAutoApproveUpToHint: 'Valor máximo padrão para autoaprovação de requisições.',
    autoCreateDraftBillOnReady: 'Gerar rascunho de fatura ao marcar pedido como pronto',
    autoCreateDraftBillOnReadyHint:
      'Cria automaticamente uma conta em rascunho vinculada ao pedido quando ele é marcado como pronto.',
    matchingMode: 'Modo de conferência',
    matchingModeHint:
      'Two-way compara pedido e fatura. Three-way exige confirmação de recebimento conforme o método escolhido.',
    allowedThreeWayReceiptGates: 'Métodos de recebimento permitidos',
    allowedThreeWayReceiptGatesHint:
      'Quando ambos estiverem habilitados, o comprador escolhe o método ao marcar o pedido como pronto.',
    defaultThreeWayReceiptGate: 'Método padrão de recebimento',
    threeWayReceiptGate: {
      BEFORE_BILL: 'Receber antes de vincular fatura',
      BEFORE_PO_CLOSE: 'Receber antes de encerrar o pedido',
    },
    matchingModeTwoWay: 'Two-way (pedido × fatura)',
    matchingModeThreeWay: 'Three-way (pedido × recebimento × fatura)',
    requireCompetitiveQuotes: 'Exigir cotações competitivas',
    requireCompetitiveQuotesHint: 'Bloqueia conversão em pedido sem cotações mínimas registradas.',
    minQuotes: 'Mínimo de fornecedores',
    minQuotesHint: 'Quantidade mínima de fornecedores com cotação registrada.',
    defaultOverBillingTolerancePercent: 'Tolerância de over-billing (%)',
    defaultOverBillingTolerancePercentHint: 'Percentual padrão acima do valor do pedido.',
    defaultOverBillingToleranceAmount: 'Tolerância de over-billing (valor)',
    defaultOverBillingToleranceAmountHint: 'Valor absoluto padrão acima do pedido.',
    defaultBuyerUserIds: 'Compradores padrão',
    defaultBuyerUserIdsHint: 'Usuários sugeridos como responsáveis pela compra.',
    defaultReceiverUserIds: 'Recebedores padrão',
    defaultReceiverUserIdsHint: 'Usuários sugeridos para verificação/recebimento.',
    budgetExceptionApproverUserIds: 'Aprovadores de exceção orçamentária',
    budgetExceptionApproverUserIdsHint:
      'Usuários com permissão para aprovar estouros de orçamento.',
    optionalPlaceholder: 'Opcional',
    discard: 'Descartar alterações',
    save: 'Salvar configurações',
    saving: 'Salvando...',
    noChangesRecorded: 'Nenhuma alteração registrada',
    lastUpdated: 'Última alteração em {{date}} por {{user}}',
  },
} as const;

export const procurementEn = {
  breadcrumbs: {
    ap: 'AP',
    procurement: 'Procurement',
    policies: 'Policies',
    newRequest: 'New request',
  },
  list: {
    title: 'Procurement',
    subtitle: 'Purchase requests, approvals and purchase orders',
    newRequest: 'New request',
    newOrder: 'New purchase order',
    searchPlaceholder: 'Search by number or title',
    requestStatusFilter: 'Request status',
    orderStatusFilter: 'Order status',
    allRequestStatuses: 'All request statuses',
    allOrderStatuses: 'All order statuses',
    tabs: {
      requests: 'Purchase requests',
      orders: 'Purchase orders',
    },
    pages: {
      requestsTitle: 'Purchase requests',
      ordersTitle: 'Purchase orders',
    },
    countRequests_one: '{{count}} request',
    countRequests_other: '{{count}} requests',
    countOrders_one: '{{count}} order',
    countOrders_other: '{{count}} orders',
    actions: {
      menuLabel: 'Actions for {{number}}',
      edit: 'Edit',
      submit: 'Submit',
      cancelRequest: 'Cancel request',
      cancelOrder: 'Cancel order',
    },
    cancelDialog: {
      requestTitle: 'Cancel request?',
      requestDescription: 'Request {{number}} will be cancelled.',
      orderTitle: 'Cancel order?',
      orderDescription: 'Order {{number}} will be cancelled.',
    },
    columns: {
      number: 'Number',
      title: 'Title',
      status: 'Status',
      amount: 'Amount',
      total: 'Total',
      requester: 'Requester',
      created: 'Created',
      needBy: 'Needed by',
      approved: 'Approved',
      ready: 'Ready at',
      expires: 'Expires at',
      owner: 'Owner',
      createdBy: 'Created by',
      originRequest: 'Origin request',
      relatedOrders: 'Generated orders',
      actions: 'Actions',
      customize: 'Columns',
      customizeHint: 'Choose which columns are shown in the list.',
      reorderHint: 'Drag the handle to reorder columns in the table.',
      resetOrder: 'Reset column order',
      dragHandleAria: 'Reorder column',
      dataType: {
        date: 'Date',
        text: 'Text',
        status: 'Status',
        currency: 'Amount',
        classification: 'Classification',
        boolean: 'Yes/No',
        actions: 'Actions',
      },
    },
    loading: 'Loading...',
    loadingRequests: 'Loading purchase requests...',
    loadingOrders: 'Loading purchase orders...',
    requestsLoadError: 'Could not load purchase requests.',
    ordersLoadError: 'Could not load purchase orders.',
    loadErrorDescription: 'Check your connection and try again.',
    retry: 'Try again',
    backToList: 'Back to list',
    permissionDeniedTitle: 'You do not have access to this record.',
    permissionDeniedDescription:
      'Ask an administrator for the required permission or return to the list.',
    emptyRequests: 'No purchase requests found.',
    emptyOrders: 'No purchase orders found.',
    emptyFilteredDescription: 'Adjust or clear the filters to see other results.',
    emptyState: {
      requestsTitle: 'No purchase requests yet',
      requestsDescription: 'Create your first purchase request to start the approval flow.',
      ordersTitle: 'No purchase orders yet',
      ordersDescriptionDirect: 'Create your first purchase order to get started.',
      ordersDescriptionRequiresRequest:
        'Purchase orders must originate from an approved purchase request. Create a request to get started, or adjust settings to allow direct orders.',
      editSettings: 'Edit settings',
    },
    activeFilters: {
      label: 'Active filters',
      clearAll: 'Clear all',
      none: 'None',
      dateRange: '{{from}} – {{to}}',
      dateFrom: 'From {{from}}',
      dateTo: 'Until {{to}}',
      amountValue: '{{operator}} {{value}}',
    },
    pagination: {
      page: 'Page',
      of: 'of',
      results: 'results',
      previous: 'Previous',
      next: 'Next',
      perPage: '/ page',
      pageSize: 'Items per page',
    },
    exploration: {
      density: {
        label: 'Table density',
        decrease: 'Decrease row height',
        increase: 'Increase row height',
        levels: {
          compact: 'Compact',
          default: 'Default',
          comfortable: 'Comfortable',
        },
      },
      grouping: {
        label: 'Group by',
        expandAll: 'Expand all',
        collapseAll: 'Minimize all',
        emptyValue: 'No information',
        itemCount_one: '{{count}} record',
        itemCount_other: '{{count}} records',
        options: {
          none: 'No grouping',
          requester: 'Created by',
          status: 'Status',
          created: 'Created',
          approved: 'Approved',
          originRequest: 'Origin request',
        },
      },
    },
    table: {
      filterColumnTooltip: 'Click to filter by this column',
      sortBy: 'Sort by {{column}}',
    },
    filters: {
      numberPlaceholder: 'Filter by number',
      titlePlaceholder: 'Filter by title',
      requesterPlaceholder: 'Filter by requester',
      relatedOrdersPlaceholder: 'Filter by generated order',
      originRequestPlaceholder: 'Filter by origin request',
      noRequesterOptions: 'No users found.',
      amountPlaceholder: 'Amount',
      createdDatePlaceholder: 'Filter by created date',
      needByDatePlaceholder: 'Filter by needed-by date',
      approvedDatePlaceholder: 'Filter by approved date',
      readyDatePlaceholder: 'Filter by ready date',
      expiresDatePlaceholder: 'Filter by expiration date',
    },
    amountOperators: {
      eqSymbol: '=',
      gteSymbol: '≥',
      lteSymbol: '≤',
    },
  },
  requestStatus: {
    OPEN: 'Open',
    PENDING_APPROVAL: 'Pending approval',
    APPROVED: 'Approved',
    CONVERTED: 'Converted',
    REJECTED: 'Rejected',
    CANCELLED: 'Cancelled',
  },
  purchaseType: {
    ONE_TIME: 'One-off',
    RECURRING: 'Recurring',
    BLANKET: 'Blanket agreement',
  },
  approvalStepStatus: {
    PENDING: 'Pending',
    IN_PROGRESS: 'In progress',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    SKIPPED: 'Skipped',
    ESCALATED: 'Escalated',
  },
  orderStatus: {
    OPEN: 'Open',
    READY: 'Ready',
    PARTIALLY_RECEIVED: 'Partially received',
    RECEIVED: 'Received',
    FULFILLED: 'Fulfilled',
    SETTLED: 'Settled',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
  },
  orderForm: {
    title: 'New purchase order',
    subtitle: 'Create a purchase order directly, without a prior purchase request.',
    disabledByPolicy:
      'Purchase orders without a request are disabled in tenant procurement settings.',
    createSuccess: 'Purchase order created',
    createError: 'Could not create the purchase order',
  },
  form: {
    title: 'New purchase request',
    subtitle: 'Create a request that will be routed through procurement approval.',
    requestDetails: 'Request details',
    lineItems: 'Line items',
    attachments: 'Attachments',
    attachmentsDescription: 'Specifications, contracts, approvals, or other supporting documents.',
    summary: 'Summary',
    estimatedAmount: 'Line-item estimate',
    budgetRequestedAmount: 'Budget requested',
    expectedAmount: 'Expected amount',
    finalAmount: 'Negotiated final amount',
    paymentTerms: 'Payment conditions',
    paymentTermsPlaceholder: 'E.g. Net 30, 50% on delivery and 50% in 30 days',
    responsibleUser: 'Verification responsible',
    entity: 'Entity',
    vendor: 'Vendor',
    vendors: 'Vendors',
    department: 'Department',
    number: 'Number',
    numberAutoGenerated: 'Assigned automatically on save',
    costCenter: 'Cost center',
    managerialAccount: 'Managerial account',
    glAccount: 'GL account',
    glAccountStale: 'Outdated',
    glAccountStaleHint:
      'The classification belongs to an earlier chart version or has no recorded version. Remap it onto the applicable chart.',
    glAccountRemap: 'Remap account',
    glAccountRemapDialogTitle: 'Remap GL account',
    glAccountRemapDialogDescription:
      'Pick the equivalent account for the header and every previously classified line. The change is complete only when all entries use the same chart version.',
    glAccountRemapDialogDescriptionLinesOnly:
      'Review the previously classified line accounts. The change is complete only when all entries use the same chart version.',
    glAccountRemapDialogDescriptionLine:
      "Pick the equivalent account on the entity's current chart of accounts for line {{lineNumber}} ({{description}}). Only this line's GL account changes.",
    glAccountRemapCurrent: 'Current account',
    glAccountRemapNew: 'New account',
    glAccountRemapSelectionsRequired: 'Select the new account for: {{pending}}.',
    glAccountRemapSelectionPending: 'Select another equivalent account on this chart version.',
    glAccountRemapPendingHeader: 'purchase order header',
    glAccountRemapPendingLine: 'line {{lineNumber}} ({{description}})',
    glAccountRemapLinesTitle: 'Classified line accounts',
    glAccountRemapLinesDescription:
      'Valid lines keep their current account. Select another account only for pending lines.',
    glAccountRemapConfirm: 'Remap',
    glAccountRemapSuccess: 'All classified accounts on the purchase order were remapped.',
    glAccountRemapBillSuccess: "The purchase order was remapped onto the bill's chart version.",
    glAccountRemapLineSuccess: "The line's GL account was remapped.",
    glAccountRemapPartial:
      'The remap is incomplete. Still pending: {{pending}}. Select another equivalent account on this version and confirm again.',
    glAccountRemapError: 'Could not remap the GL account.',
    glAccountRemapNoTargetsTitle: 'No classification to remap',
    glAccountRemapNoTargets:
      'This purchase order has no header GL account or classified lines. No changes were made.',
    glAccountRemapBlockedTitle: 'This purchase order cannot be remapped',
    glAccountRemapBlockedStatus:
      'The purchase order has status “{{status}}”, which does not allow GL classification changes.',
    glAccountRemapBlockedPermission:
      'You do not have permission to change this purchase order classification.',
    glAccountRemapAccountingDate: 'Reference date (optional)',
    glAccountRemapAccountingDateHint:
      'Leave blank to remap onto the current chart of accounts. Provide a date to resolve the chart in force on that date instead, if the classification needs to reflect an earlier version after more than one chart cutover.',
    glAccountRemapAccountingDateBillHint:
      "This date comes from the blocked bill's competency or issue date and keeps every selection on the chart resolved for it.",
    glAccountRemapBillContext:
      'Remap requested by bill {{billNumber}}, with accounting date {{accountingDate}}. Open bill.',
    glAccountRemapBill: 'linked bill',
    glAccountRemapHistoricalTitle: "Classification on the bill's version",
    glAccountRemapHistoricalNote:
      'This purchase order is classified on the chart version for bill {{billNumber}}, dated {{accountingDate}}.',
    glAccountRemapOpenBill: 'Open bill {{billNumber}}',
    lineGlAccountRemediationTitle: 'Lines with an outdated GL account',
    lineGlAccountRemediationDescription:
      'These lines use an earlier version or have no recorded version. Remap each one onto the applicable chart.',
    classification: 'Classification',
    customSegments: 'Custom fields',
    customSegmentsHint: 'Segments used for budget matching on this request.',
    titleField: 'Title',
    needByDate: 'Need-by date',
    needByDateHint: 'When the goods or services must be available',
    firstPaymentDate: 'First payment date',
    purchaseType: 'Purchase type',
    recurringSchedule: 'Recurring schedule',
    recurrenceFrequency: 'Frequency',
    perOccurrenceAmount: 'Amount per occurrence',
    recurringSince: 'Recurring start',
    recurringUntil: 'Recurring end',
    recurrenceFrequencyOptions: {
      WEEKLY: 'Weekly',
      MONTHLY: 'Monthly',
      BIMONTHLY: 'Bimonthly',
      QUARTERLY: 'Quarterly',
      SEMESTERLY: 'Semesterly',
      YEARLY: 'Yearly',
    },
    tooltips: {
      purchaseType:
        'One-time: single purchase (equipment, one-off project). Recurring: repeated payments (rent, subscription, contract).',
      purchaseTypeAria: 'Help for purchase type',
      needByDate: 'When the goods or services must be available or delivered.',
      firstPaymentDate: 'Date when the first payment for this recurring purchase should occur.',
      recurrenceFrequency: 'How often the payment repeats (monthly, quarterly, etc.).',
      recurrenceFrequencyAria: 'Help for recurrence frequency',
      perOccurrenceAmount:
        'Amount for each recurring installment or invoice. Used to create the recurring bill template and monthly commitments.',
      perOccurrenceAmountAria: 'Help for amount per occurrence',
      recurringSince:
        'Date of the first expected occurrence. Defines when recurring commitments start.',
      recurringSinceAria: 'Help for recurring start date',
      recurringUntil:
        'Optional. Date of the last expected occurrence. Leave empty for open-ended contracts.',
      recurringUntilAria: 'Help for recurring end date',
      budgetRequestedAmount:
        'Total amount to reserve in the budget for approval. May exceed the line-item estimate if you already know the contract ceiling.',
      budgetRequestedAmountAria: 'Help for budget requested',
      responsibleUser:
        'Person who validates quotes and confirms supplier terms before the order is ready for billing.',
      responsibleUserAria: 'Help for verification responsible',
      paymentTerms:
        'Negotiated terms such as net days, installments, or milestones (e.g. net 30, 50% on delivery).',
      paymentTermsAria: 'Help for payment conditions',
      vendors:
        'Candidate suppliers. Optional on the request — can be set when marking the order ready.',
      vendorsAria: 'Help for vendors',
      estimatedAmount:
        'Sum of line items on this request. Used as a reference; budget checks use Budget requested.',
      estimatedAmountAria: 'Help for estimated amount',
    },
    description: 'Description',
    selectEntity: 'Select entity',
    selectEntityFirst: 'Select an entity first.',
    select: 'Select',
    optionalVendor: 'Optional vendor',
    optionalDepartment: 'Optional department',
    optionalCostCenter: 'Optional cost center',
    titlePlaceholder: 'What is being requested?',
    datePlaceholder: 'dd/mm/yyyy',
    currencyPlaceholder: '0.00',
    descriptionPlaceholder: 'Context for approvers',
    addLine: 'Add line',
    removeLine: 'Remove line',
    lineDescription: 'Description',
    quantity: 'Qty',
    unitPrice: 'Unit price',
    amount: 'Total',
    lineSubtotal: 'Line subtotal',
    cancel: 'Cancel',
    createRequest: 'Create request',
    editTitle: 'Edit purchase request',
    editBreadcrumb: 'Edit request',
    saveChanges: 'Save changes',
    loadingRequest: 'Loading purchase request...',
    notEditable: 'Only draft purchase requests can be edited.',
    updateSuccess: 'Purchase request updated.',
    updateError: 'Could not update the purchase request.',
    requiredFieldsError: 'Fill in the required fields.',
    fieldErrors: {
      vendorsRequired: 'Select at least one vendor.',
      entityRequired: 'Select the entity.',
      titleRequired: 'Enter the title.',
      needByDateRequired: 'Enter a valid date in dd/mm/yyyy format.',
      budgetRequestedRequired: 'Enter the budget requested.',
      positiveTotalRequired: 'Enter at least one line item with a positive amount.',
      recurrenceFrequencyRequired: 'Select the recurrence frequency.',
      recurringSinceRequired: 'Enter the recurrence start date.',
      perOccurrenceAmountRequired: 'Enter the amount per occurrence.',
      recurringUntilInvalid: 'Enter a valid end date in dd/mm/yyyy format.',
      recurringUntilBeforeStart: 'The end date must be on or after the start date.',
    },
    createSuccess: 'Purchase request created.',
    createError: 'Failed to create purchase request.',
    recurringScheduleValidationError:
      'Provide frequency, recurring start date, and amount per occurrence. If you set an end date, it must be after the start date.',
    recurringClassificationMismatch:
      'Recurring purchase orders require all line items to use the same classification as the header.',
    loadErrorTitle: 'Could not load the form.',
    loadErrorDescription: 'Check your connection and try again.',
    retry: 'Try again',
    unsavedChanges: {
      title: 'Discard changes?',
      description: 'Your unsaved changes will be lost if you leave this page.',
      proceed: 'Leave without saving',
      stay: 'Keep editing',
    },
    uploadPartial: 'Request created, but some attachments failed to upload.',
    upload: {
      dropTitle: 'Drag files here or click to browse',
      dropHint: 'PDF, images, or spreadsheets — up to {{max}} files',
      dropActive: 'Drop files here',
      selectFiles: 'Select files',
      filesSelected: '{{count}} file(s) selected',
    },
  },
  requestDetail: {
    subtitle: 'Purchase request {{number}}',
    tabs: {
      items: 'Line items',
      approval: 'Approval',
      details: 'Details',
    },
    summary: {
      requester: 'Requester',
      entity: 'Entity',
      vendor: 'Vendor',
      created: 'Created',
      needByDate: 'Need-by date',
      purchaseType: 'Purchase type',
      description: 'Description',
      department: 'Department',
      costCenter: 'Cost center',
      managerialAccount: 'Managerial account',
      glAccount: 'GL account',
      customSegments: 'Custom fields',
      number: 'Number',
      notSet: '—',
    },
    lineItems: 'Line items',
    vendorQuotes: {
      title: 'Vendor sourcing',
      helper:
        'Record the proposals received for this request and compare vendors before choosing the winner.',
      vendor: 'Vendor',
      amount: 'Quoted amount',
      amountRequired: 'Enter the quoted amount.',
      validUntil: 'Valid until',
      validUntilInvalid: 'Enter a valid quote expiration date in dd/mm/yyyy format.',
      note: 'Notes',
      attachments: 'Attachments',
      selected: 'Winner',
      editQuote: 'Edit',
      completeQuote: 'Complete quote',
      selectWinner: 'Select winner',
      requirementProgress:
        '{{registered}} of {{minimum}} quotes recorded. {{missing}} more required before converting to a purchase order.',
      requirementNeedsMoreVendors:
        '{{registered}} of {{minimum}} quotes recorded. All linked vendors already have a quote — add {{missing}} more vendor(s) to reach the minimum and convert to a purchase order.',
      requirementReady:
        '{{minimum}} quotes recorded. You can compare proposals and choose a winner.',
      recordQuote: 'Record quote',
      uploadAttachment: 'Attach quote',
      openingAttachment: 'Opening attachment...',
      openAttachmentError: 'Could not open the attachment.',
      showAllQuotes: 'View other quotes ({{count}})',
      showFewerQuotes: 'Hide other quotes',
      empty: 'No quotes recorded yet.',
      emptyHint: 'Add the first proposal to start comparing vendors.',
      emptyReadOnlyHint: 'Quotes will appear here when they are recorded.',
      addQuote: 'Add quote',
      allVendorsQuoted: 'All linked vendors already have a quote recorded.',
      noLinkedVendors: 'Add vendors to the order before recording quotes.',
      formTitle: 'New quote',
      editQuoteTitle: 'Edit quote',
      completeQuoteTitle: 'Complete quote',
      formHint: 'Select the vendor and record the proposal details.',
      closeForm: 'Close',
      cancel: 'Cancel',
      notInformed: 'Not provided',
      amountRequiredForWinner: 'No quoted amount. Edit this quote to enter the amount.',
      vendorRequired: 'Select a vendor.',
      recordQuoteSuccess: 'Quote recorded.',
      recordQuoteError: 'Could not record the quote.',
      selectedQuoteChangeRequiresAmendment:
        'Selected quote changes require a purchase order amendment after it is ready.',
      selectWinnerSuccess: 'Winning vendor selected.',
      selectWinnerError: 'Could not select the winning vendor.',
      uploadAttachmentSuccess: 'Quote attached.',
      uploadAttachmentError: 'Could not attach the quote.',
    },
    approvalChain: 'Approval chain',
    status: 'Status',
    estimatedAmount: 'Line-item estimate',
    vendorId: 'Vendor ID',
    convertedMessage: 'This request has been converted to a purchase order.',
    convertedOrderMessage: 'This request has been converted to purchase order',
    needByDateOverdue: 'The need-by date has passed. This request may not be sourced in time.',
    viewOrders: 'View orders',
    noApprovalChain: 'No approval chain yet.',
    noAssignee: 'No assignee',
    loading: 'Loading purchase request...',
    notFound: 'Purchase request not found.',
    loadErrorTitle: 'Could not load the purchase request.',
    loadErrorDescription: 'Check your connection and try again.',
    back: 'Back',
    edit: 'Edit',
    cancelRequest: 'Cancel request',
    submit: 'Submit',
    retrySubmit: 'Retry submit',
    reject: 'Reject',
    approve: 'Approve',
    submitSuccess: 'Purchase request submitted for approval.',
    submitError: 'Failed to submit purchase request.',
    noApproversConfigured:
      'No approvers are configured for this step. Configure approvers before submitting.',
    approveSuccess: 'Purchase request approved.',
    approveError: 'Failed to approve purchase request.',
    budgetConfirmation: {
      title: 'No matching budget line',
      description:
        'No active budget line matches one or more items on this request. The purchase order will be created without a budget commitment.',
      linesLabel: 'Unmatched line items: {{lines}}',
      confirm: 'Approve without budget commitment',
      cancel: 'Go back to edit',
    },
    budgetBlock: {
      hardTitle: 'Approval blocked — budget exceeded',
      hardDescription:
        'Final approval would create a commitment above the budget line limit below. Reduce the amount, adjust dimensions, or edit the budget before approving.',
      softTitle: 'Budget exception required',
      softDescription:
        'Final approval would exceed a soft-blocked budget line. Request and obtain approval for an exception before completing approval.',
      blockingLine: 'Blocking line',
      assessedPeriod: 'Assessed period',
      lineLimitSuffix: 'line limit',
      excessAmount: 'Excess: {{amount}}',
      hardActions:
        'Edit the request to reduce the amount, change cost center/managerial account, or increase the line limit in the budget.',
      softActions:
        'Request a budget exception for this purchase request or reduce the amount before approving.',
      requestException: 'Request exception',
      exceptionPending: 'Budget exception pending finance approval.',
      exceptionApproved: 'Exception approved — you can complete approval.',
      requestExceptionDialogTitle: 'Request budget exception',
      requestExceptionDialogDescription:
        'Explain why this request should be approved above the limit for line {{lineName}}.',
      requestExceptionJustificationPlaceholder: 'Exception justification',
      requestExceptionSubmit: 'Submit request',
      requestExceptionSuccess: 'Budget exception requested.',
      requestExceptionError: 'Failed to request budget exception.',
      dimensionFallback: {
        COST_CENTER: 'Cost center',
        DEPARTMENT: 'Department',
        COMPANY: 'Company',
      },
    },
    rejectSuccess: 'Purchase request rejected.',
    rejectError: 'Failed to reject purchase request.',
    cancelSuccess: 'Purchase request cancelled.',
    cancelError: 'Failed to cancel purchase request.',
    columns: {
      lineNumber: '#',
      description: 'Description',
      quantity: 'Qty',
      unitPrice: 'Unit price',
      total: 'Total',
    },
    sections: {
      requestDetails: 'Request details',
      requestedItems: 'Requested items',
      attachments: 'Attachments',
      approvalFlow: 'Approval flow',
      generatedOrders: 'Generated purchase orders',
    },
    summaryCard: {
      items: 'Items',
      attachments: 'Attachments',
      generatedOrders: 'Generated orders',
      budgetStatus: 'Budget status',
      budgetWithinLimit: 'Within limit',
      itemUnits: '{{count}} item · {{units}} units',
      itemUnits_other: '{{count}} items · {{units}} units',
    },
    vendorPendingConversion: 'To be defined on conversion',
    noDescription: 'No description',
    estimatedTotal: 'Estimated line-item total',
    attachmentsEmpty: 'No attachments yet.',
    addAttachment: 'Add attachment',
    uploadSuccess: 'Attachment uploaded successfully.',
    uploadError: 'Failed to upload attachment.',
    attachmentsLoading: 'Loading attachments...',
    openingAttachment: 'Opening attachment...',
    openAttachmentError: 'Could not open the attachment.',
    showAllAttachments: 'View other attachments ({{count}})',
    showFewerAttachments: 'Hide other attachments',
    closeAttachmentUpload: 'Close',
    deleteAttachment: 'Remove attachment',
    deleteAttachmentConfirmTitle: 'Remove attachment?',
    deleteAttachmentConfirmDescription:
      'The attachment "{{name}}" will be permanently removed. This action cannot be undone.',
    deleteAttachmentSuccess: 'Attachment removed.',
    deleteAttachmentError: 'Could not remove the attachment.',
    generatedOrdersEmpty:
      'No orders generated yet. After final approval, the purchase order will be created automatically.',
    generatedOrdersRestricted: 'Related orders exist, but you do not have permission to view them.',
  },
  orderDetail: {
    subtitle: 'Purchase order {{number}}',
    edit: 'Edit',
    editTitle: 'Edit purchase order',
    editBreadcrumb: 'Edit order',
    tabs: {
      items: 'Line items',
      details: 'Details',
    },
    summary: {
      entity: 'Entity',
      vendor: 'Vendor',
      approved: 'Approved',
      created: 'Created on',
      billed: 'Billed',
      sourceRequest: 'Source request',
      number: 'Number',
      notSet: '—',
    },
    lineItems: 'Line items',
    vendorQuotes: {
      title: 'Vendor quotes',
      helper:
        'Review this order’s proposals. For open orders, selecting the winner updates the final negotiated amount.',
      vendor: 'Vendor',
      amount: 'Quoted amount',
      amountRequired: 'Enter the quoted amount.',
      validUntil: 'Valid until',
      validUntilInvalid: 'Enter a valid quote expiration date in dd/mm/yyyy format.',
      note: 'Notes',
      attachments: 'Attachments',
      selected: 'Winner',
      editQuote: 'Edit',
      completeQuote: 'Complete quote',
      selectWinner: 'Select winner',
      requirementProgress:
        '{{registered}} of {{minimum}} quotes recorded. {{missing}} more required before marking the purchase order as ready.',
      requirementNeedsMoreVendors:
        '{{registered}} of {{minimum}} quotes recorded. All linked vendors already have a quote — add {{missing}} more vendor(s) to reach the minimum and mark the order as ready.',
      requirementReady: '{{minimum}} quotes recorded. You can mark the purchase order as ready.',
      recordQuote: 'Record quote',
      uploadAttachment: 'Attach quote',
      openingAttachment: 'Opening attachment...',
      openAttachmentError: 'Could not open the attachment.',
      showAllQuotes: 'View other quotes ({{count}})',
      showFewerQuotes: 'Hide other quotes',
      empty: 'No quotes recorded yet.',
      emptyHint: 'Add a proposal to start comparing vendors.',
      emptyReadOnlyHint: 'Quotes will appear here when they are recorded.',
      addQuote: 'Add quote',
      allVendorsQuoted: 'All linked vendors already have a quote recorded.',
      noLinkedVendors: 'Add vendors to the order before recording quotes.',
      formTitle: 'New quote',
      editQuoteTitle: 'Edit quote',
      completeQuoteTitle: 'Complete quote',
      formHint: 'Select the vendor and record the proposal details.',
      closeForm: 'Close',
      cancel: 'Cancel',
      notInformed: 'Not provided',
      amountRequiredForWinner: 'No quoted amount. Edit this quote to enter the amount.',
      vendorRequired: 'Select a vendor.',
      recordQuoteSuccess: 'Quote recorded.',
      recordQuoteError: 'Could not record the quote.',
      selectedQuoteChangeRequiresAmendment:
        'Selected quote changes require a purchase order amendment after it is ready.',
      selectWinnerSuccess: 'Winning vendor selected.',
      selectWinnerError: 'Could not select the winning vendor.',
      uploadAttachmentSuccess: 'Quote attached.',
      uploadAttachmentError: 'Could not attach the quote.',
    },
    status: 'Status',
    totalAmount: 'Total amount',
    approved: 'Approved',
    billed: 'Billed',
    sourceRequest: 'Source request',
    loading: 'Loading purchase order...',
    notFound: 'Purchase order not found.',
    back: 'Back',
    cancelOrder: 'Cancel order',
    markReady: 'Mark as ready',
    markFulfilled: 'Mark as fulfilled',
    readySuccess: 'Purchase order marked as ready.',
    readyError: 'Failed to mark purchase order as ready.',
    fulfillSuccess: 'Purchase order marked as fulfilled.',
    fulfillError: 'Failed to mark purchase order as fulfilled.',
    recordReceipt: 'Record receipt',
    linkedReceipt: {
      title: 'Purchase order receipt',
      loading: 'Loading receipt',
      errorTitle: 'Could not open the receipt',
      errorDescription: 'Refresh the data or try again.',
      receiptId: 'Receipt identifier',
      note: 'Note',
      lines: 'Received items',
      quantity: 'Quantity: {{quantity}}',
    },
    receiveDialogTitle: 'Record goods/services receipt',
    receiveDialogDescription:
      'Specify who received the items and received quantities per line (three-way matching).',
    receiveSuccess: 'Receipt recorded.',
    receiveError: 'Failed to record receipt.',
    receiveErrorDetails: {
      lineRepeated:
        'The same item was entered more than once in the receipt. Review the lines and try again.',
      lineNotFound:
        'One of the submitted items no longer belongs to this purchase order. Refresh the page and try again.',
      quantityExceedsPending:
        'The available quantity changed or has already been received. Refresh the purchase order and try again.',
    },
    receivedAt: 'Received on',
    readyDialogTitle: 'Mark purchase order as ready',
    readyDialogDescription:
      'Confirm vendor, payment conditions, final amount, and verification responsible.',
    readyValidation: {
      vendorsRequired: 'Select at least one vendor.',
      paymentTermsRequired: 'Enter payment conditions.',
      finalAmountRequired: 'Enter the final amount.',
      responsibleUserRequired: 'Select the verification responsible user.',
      draftBillVendorRequired: 'Select the draft bill vendor.',
      recurringScheduleRequired:
        'Complete the recurring schedule on the purchase order before marking it as ready.',
      buyerVerificationConflict:
        'The verification responsible must be different from the buyer marking the order ready.',
    },
    receiveValidation: {
      responsibleUserRequired: 'Select who received the items.',
      receiverBuyerConflict:
        'The receiver must be different from the buyer who marked the order ready.',
      quantityPositive: 'Enter a quantity greater than zero.',
      quantityExceedsPending: 'Enter no more than {{pending}} item(s), the pending balance.',
      atLeastOneQuantity: 'Enter at least one received quantity greater than zero.',
    },
    receiptRequiredBeforeClose:
      'Record the item receipt before marking the purchase order as fulfilled.',
    threeWayReceiptGate: 'Receipt method',
    threeWayReceiptGateHint: {
      BEFORE_BILL: 'Receipt must be recorded before linking or submitting the bill.',
      BEFORE_PO_CLOSE:
        'The bill may be linked before receipt; receipt is required before closing the purchase order.',
    },
    draftBillVendor: 'Draft bill vendor',
    draftBillVendorHint: 'Choose which vendor the automatically generated draft bill should use.',
    cancelSuccess: 'Purchase order cancelled.',
    cancelError: 'Failed to cancel purchase order.',
    saveChanges: 'Save changes',
    updateSuccess: 'Purchase order updated.',
    updateError: 'Could not update the purchase order.',
    uploadPartial: 'Purchase order updated, but some attachments failed to upload.',
    uploadPartialDuplicateNames:
      'Files with the same name failed. We kept them selected; remove any you do not want to resend.',
    notEditable: 'Only open purchase orders can be edited.',
    loadErrorTitle: 'Could not load the purchase order.',
    loadErrorDescription: 'Check your connection and try again.',
    sections: {
      attachments: 'Attachments',
      linkedBills: 'Linked bills',
      budgetCommitment: 'Committed budget line',
      sourceRequest: 'Source request',
    },
    sourceRequestEmpty: 'This order has no linked source request.',
    sourceRequestRestricted:
      'A source request is linked, but you do not have permission to view it.',
    relatedRequestLoading: 'Loading request...',
    sourceRequestUnavailable: 'The source request could not be loaded.',
    attachmentsEmpty: 'No attachments yet.',
    addAttachment: 'Add attachment',
    uploadSuccess: 'Attachment uploaded successfully.',
    uploadError: 'Failed to upload attachment.',
    attachmentsLoading: 'Loading attachments...',
    openingAttachment: 'Opening attachment...',
    openAttachmentError: 'Could not open the attachment.',
    showAllAttachments: 'View other attachments ({{count}})',
    showFewerAttachments: 'Hide other attachments',
    closeAttachmentUpload: 'Close',
    deleteAttachment: 'Remove attachment',
    deleteAttachmentConfirmTitle: 'Remove attachment?',
    deleteAttachmentConfirmDescription:
      'The attachment "{{name}}" will be permanently removed. This action cannot be undone.',
    deleteAttachmentSuccess: 'Attachment removed.',
    deleteAttachmentError: 'Could not remove the attachment.',
    linkedBillsEmpty: 'No bills linked to this order.',
    expiresAt: 'Order expiration',
    readyAt: 'Marked ready',
    fulfilledAt: 'Fulfilled on',
    utilized: 'Utilized',
    available: 'Available',
    utilization: 'Utilization',
    columns: {
      lineNumber: '#',
      description: 'Description',
      quantity: 'Qty',
      unitPrice: 'Unit price',
      total: 'Total',
    },
  },
  policies: {
    title: 'Procurement policies',
    subtitle: 'Configure which workflow approves each purchase request',
    refresh: 'Refresh',
    newPolicy: 'New policy',
    searchPlaceholder: 'Search by name or description',
    showingActive: 'Showing active',
    showingAll: 'Showing all',
    count: '{{count}} policies',
    empty: 'No procurement policies found.',
    noDescription: 'No description',
    noWorkflow: 'No workflow',
    active: 'Active',
    inactive: 'Inactive',
    columns: {
      name: 'Name',
      workflow: 'Workflow',
      status: 'Status',
      priority: 'Priority',
      specificity: 'Specificity',
    },
  },
  policyForm: {
    newTitle: 'New procurement policy',
    editTitle: 'Procurement policy',
    subtitle: 'Control which workflow handles purchase request approvals',
    back: 'Back',
    delete: 'Delete',
    save: 'Save',
    deleteConfirm: 'Delete this procurement policy?',
    createSuccess: 'Policy created.',
    updateSuccess: 'Policy updated.',
    deleteSuccess: 'Policy deleted.',
    saveError: 'Could not save policy.',
    deleteError: 'Could not delete policy.',
    basics: 'Basics',
    conditions: 'Workflow conditions',
    summary: 'Summary',
    name: 'Name',
    description: 'Description',
    entity: 'Entity',
    workflow: 'Workflow',
    selectWorkflow: 'Select a workflow',
    noWorkflow: 'No workflow',
    status: 'Status',
    selectStatus: 'Select status',
    priority: 'Priority',
    evaluationMode: 'Evaluation mode',
    deterministic: 'Deterministic',
    ai: 'AI',
    vendor: 'Vendor',
    vendors: 'Allowed vendors',
    requireVendorForApproval: 'Require vendor to approve purchase requests',
    department: 'Department',
    managerialAccount: 'Managerial account',
    glAccountId: 'GL account ID',
    glAccountPlaceholder: 'Optional manual ID',
    autoApproveUpTo: 'Auto-approve up to',
    minAmount: 'Minimum amount',
    maxAmount: 'Maximum amount',
    selectEntityFirst: 'Select an entity first.',
    policyId: 'Policy ID',
    specificity: 'Specificity',
    created: 'Created',
    updated: 'Updated',
  },
  labels: {
    loading: 'Loading...',
  },
  filters: {
    all: 'All',
  },
  purchaseOrder: {
    selector: {
      label: 'Purchase order',
      placeholder: 'Select a purchase order',
      searchPlaceholder: 'Search by number or title...',
      empty: 'No purchase orders available.',
      notFound: 'No purchase orders found.',
      loading: 'Loading purchase orders...',
      listHeading: 'Purchase orders',
      clearAria: 'Clear selection',
    },
    validation: {
      checking: 'Validating purchase order...',
      remapAction: 'Remap order for this bill',
      remapDateRequired:
        'Enter the bill competency or issue date first so Alchemy ERP can identify the correct chart of accounts.',
      EXPIRED: {
        title: 'Purchase order expired',
        description: 'The selected purchase order has expired.',
      },
      FULFILLED: {
        title: 'Purchase order fully billed',
        description: 'The selected purchase order has already been fully billed.',
      },
      NOT_READY: {
        title: 'Purchase order not ready',
        description: 'The purchase order must be marked ready before linking to a bill.',
      },
      AMOUNT_EXCEEDED: {
        title: 'Amount exceeds purchase order',
        description: 'The bill amount exceeds the available balance on the purchase order.',
      },
      VENDOR_NOT_ALLOWED: {
        title: 'Vendor not allowed',
        description: 'The bill vendor is not linked to the selected purchase order.',
      },
      GL_CLASSIFICATION_STALE: {
        title: 'Stale classification',
        description:
          'The GL account classified on this order belongs to a different chart-of-accounts version than the one this bill resolves to. Remap the account before converting to a bill.',
      },
      GL_CLASSIFICATION_INCOMPLETE: {
        title: 'Incomplete classification',
        description:
          'The GL account classified on this order has no chart-of-accounts version recorded, so it cannot be validated against the version this bill resolves to. Remap the account before converting to a bill.',
      },
    },
  },
  globalSettings: {
    title: 'Procurement settings',
    subtitle: 'Define global defaults for purchase requests and orders',
    cardTitle: 'Global defaults',
    loading: 'Loading settings...',
    allowPurchaseOrdersWithoutPurchaseRequest: 'Allow purchase orders without a request',
    allowPurchaseOrdersWithoutPurchaseRequestHint:
      'When enabled, buyers can create purchase orders directly without a prior purchase request.',
    enforcePurchaseRequestSelfApprovalGuard: 'Block self-approval on purchase requests',
    enforcePurchaseRequestSelfApprovalGuardHint:
      'When enabled, the requester cannot approve their own purchase request (separation of duties).',
    requireVendor: 'Require vendor',
    requireVendorHint: 'Requires a linked vendor before approving purchase requests.',
    defaultPoExpirationDays: 'Default PO expiration (days)',
    defaultPoExpirationDaysHint: 'Leave blank to skip a default expiration.',
    defaultAutoApproveUpTo: 'Default auto-approve up to',
    defaultAutoApproveUpToHint: 'Default maximum amount for purchase request auto-approval.',
    autoCreateDraftBillOnReady: 'Auto-create draft bill when marking PO ready',
    autoCreateDraftBillOnReadyHint:
      'Automatically creates a draft AP bill linked to the purchase order when it is marked ready.',
    matchingMode: 'Matching mode',
    matchingModeHint:
      'Two-way matches PO to invoice. Three-way requires receipt confirmation per the selected method.',
    allowedThreeWayReceiptGates: 'Allowed receipt methods',
    allowedThreeWayReceiptGatesHint:
      'When both are enabled, the buyer chooses the method when marking the order ready.',
    defaultThreeWayReceiptGate: 'Default receipt method',
    threeWayReceiptGate: {
      BEFORE_BILL: 'Receive before linking bill',
      BEFORE_PO_CLOSE: 'Receive before closing PO',
    },
    matchingModeTwoWay: 'Two-way (PO × invoice)',
    matchingModeThreeWay: 'Three-way (PO × receipt × invoice)',
    requireCompetitiveQuotes: 'Require competitive quotes',
    requireCompetitiveQuotesHint: 'Blocks PO conversion until minimum quotes are recorded.',
    minQuotes: 'Minimum vendors',
    minQuotesHint: 'Minimum vendors with recorded quotes.',
    defaultOverBillingTolerancePercent: 'Over-billing tolerance (%)',
    defaultOverBillingTolerancePercentHint: 'Default percent above PO amount.',
    defaultOverBillingToleranceAmount: 'Over-billing tolerance (amount)',
    defaultOverBillingToleranceAmountHint: 'Default absolute amount above PO total.',
    defaultBuyerUserIds: 'Default buyers',
    defaultBuyerUserIdsHint: 'Suggested users responsible for purchasing.',
    defaultReceiverUserIds: 'Default receivers',
    defaultReceiverUserIdsHint: 'Suggested users for verification/receipt.',
    budgetExceptionApproverUserIds: 'Budget exception approvers',
    budgetExceptionApproverUserIdsHint: 'Users who may approve budget overruns.',
    optionalPlaceholder: 'Optional',
    discard: 'Discard changes',
    save: 'Save settings',
    saving: 'Saving...',
    noChangesRecorded: 'No changes recorded',
    lastUpdated: 'Last updated on {{date}} by {{user}}',
  },
} as const;
